















import Vue from 'vue';
import SelectSubscribeUser from './SelectSubscribeUser.vue';
import SelectCustomUser from './SelectCustomUser.vue';
import customerVuex from '../../../../customer/vuex/common';

export default Vue.extend({
  mixins: [customerVuex],
  components: {
    SelectSubscribeUser,
    SelectCustomUser,
  },
  data() {
    return {
      selectedTab: 'subscribe',
    };
  },
  methods: {
    confirmTopic() {
      this.$emit('confirmTopic');
    },
    confirmCustomerFilter() {
      this.$emit('confirmCustomerFilter');
    },
  },
  mounted() {
    if (!this.filterNothing) {
      this.selectedTab = 'filter';
    }
  },
});
